module Meevo.Plugins.Register {
    "use strict";

    enum ManualDiscountAllowed {
        PercentOff = 1,
        AmountOff = 2,
        SpecificPrice = 4,
        Predefined = 8
    }

    export class DiscountsSection extends Meevo.Plugins.Register.RegisterSectionBase {

        public discount: Model.DiscountLine = { type: null, discountValue: 0, isBuyGet: false, discountId: null, isStackable: true, discountSaleLineGroupId: null };
        public origDiscount: Model.DiscountLine = { type: null, discountValue: 0, isBuyGet: false, discountId: null, isStackable: true, discountSaleLineGroupId: null };
        public saleItems: any[] = [];
        public buyItems: any[] = [];
        public discountItems: any[] = [];
        public predefinedDiscounts: any[] = [];
        public discountItemsByClient: any;
        public buyItemsByClient: any;
        public selectedPredefinedDiscounts: any = null;
        private isEditing: boolean = false;
        private selectedSaleLine: Model.SaleLine;
        private selectedSaleLineDiscountIndex: number;
        public showEntryFieldType: Model.DiscountTypeEnum;
        public manualDiscountsAllowed: number;
        public saleTypeAllowed: number[] = [];
        public saleTypeRequired: number[] = [];
        public totalRequiredQuantity: number = 0;
        public totalSelectedQuantity: number = 0;
        public totalRequiredAmount: number = 0;
        public shouldSelectAll: boolean = false;
        public scannedDiscountBarCode: string;
        public performedPredefinedDiscountSearch: boolean = false;
        public labelOfNumberOfItemsToBeSelected: string = "";
        public notPreDefindedDiscountChoosen: boolean = false;
        public securityReplaceItemOnSale: Model.SecurityAccessEnum;

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        get $timeout() { return this.registerContext.$timeout; }
        get $translate() { return this.registerContext.$translate; }
        get $filter() { return this.registerContext.$filter; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get securityService() { return this.registerContext.securityService; }

        get selectDiscountsLabel() {
            return this.discount.isSpread
                ? 'MESSAGE_DISCOUNTS_SELECT_REQUIRED_SPREAD_GET'
                : 'MESSAGE_DISCOUNTS_SELECT_REQUIRED_GET';
        }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Discounts, registerContext, "discounts", Register.RegisterSectionCatTypeEnum.Other);

            this.securityService.checkSecurityKey(this.meevoSecurityKeys.REGISTER_REGISTER_DISCOUNT_REPLACEITEMONSALE + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.securityReplaceItemOnSale = result;
            });
        }

        reset() {
            this.getPredefinedDiscounts(null, null);
            this.performedPredefinedDiscountSearch = false;
            this.saleItems = this.buyItems = this.discountItems = [];
            this.discountItemsByClient = null;
            this.buyItemsByClient = null;

            _(this.registerContext.sale.saleLines).each(item => {
                if (this.registerContext.isDiscountable(item)) {
                    for (let ndx = 0, len = item.quantity; ndx < len; ndx++) {
                        let saleItem = { item: item, isSelected: false, isRequired: false };
                        this.saleItems.push(saleItem);
                    }
                }
            });

            this.discount = { type: null, discountValue: 0, isBuyGet: false, discountId: null, isStackable: true, discountSaleLineGroupId: null };
            this.origDiscount = { type: null, discountValue: 0, isBuyGet: false, discountId: null, isStackable: true, discountSaleLineGroupId: null };
            this.isEditing = false;
            this.selectedSaleLine = null;
            this.selectedSaleLineDiscountIndex = -1;
            this.selectedPredefinedDiscounts = null;
            this.shouldSelectAll = false;
            this.labelOfNumberOfItemsToBeSelected = "";

            this.manualDiscountsAllowed = 0;
            this.manualDiscountsAllowed += (this.registerContext.canAddPercentOffDiscount ? ManualDiscountAllowed.PercentOff : 0);
            this.manualDiscountsAllowed += (this.registerContext.canAddAmountOffDiscount ? ManualDiscountAllowed.AmountOff : 0);
            this.manualDiscountsAllowed += (this.registerContext.canAddSpecificPriceDiscount ? ManualDiscountAllowed.SpecificPrice : 0);
            this.manualDiscountsAllowed += (this.registerContext.canAddPredefinedDiscount ? ManualDiscountAllowed.Predefined : 0);

            this.showEntryFieldType =
                (this.registerContext.canAddPercentOffDiscount
                    ? Model.DiscountTypeEnum.PercentOff
                    : (this.registerContext.canAddAmountOffDiscount || this.registerContext.canAddSpecificPriceDiscount)
                        ? Model.DiscountTypeEnum.AmountOff
                        : 0); // predefined discount

            switch (this.manualDiscountsAllowed) {
                case ManualDiscountAllowed.PercentOff:
                    this.discount.type = Model.DiscountTypeEnum.PercentOff;
                    break;
                case ManualDiscountAllowed.AmountOff:
                    this.discount.type = Model.DiscountTypeEnum.AmountOff;
                    break;
                case ManualDiscountAllowed.SpecificPrice:
                    this.discount.type = Model.DiscountTypeEnum.SpecialPrice;
                    break;
                case ManualDiscountAllowed.Predefined:
                    this.discount.type = null;
                    break;
            }

            this.predefinedDiscounts = [];
        }

        initialize(selectedSaleLine?: Model.SaleLine, selectedDiscountLine?: Model.DiscountLine) {
            if (selectedSaleLine) {
                this.selectedSaleLine = selectedSaleLine;
                this.getPredefinedDiscounts(this.selectedSaleLine, selectedDiscountLine);
            }

            if (selectedDiscountLine) {
                this.discount = _.clone(selectedDiscountLine);
                if (this.discount.discountId != null) {
                    this.discount.type = 0;
                }
                this.origDiscount = selectedDiscountLine;
                this.showEntryFieldType = this.discount.type;

                this.selectedSaleLineDiscountIndex = _.findIndex(this.selectedSaleLine.discountLines, (discountLine: Model.DiscountLine) =>
                    discountLine.type === selectedDiscountLine.type &&
                    discountLine.discountValue === selectedDiscountLine.discountValue &&
                    discountLine.predefinedDiscount === selectedDiscountLine.predefinedDiscount
                );

                this.isEditing = true;
                if (this.discount.type === 0) {
                    this.selectAllSaleItemSelection(null, selectedDiscountLine);
                }
                else {
                    this.selectAllSaleItemSelection(this.selectedSaleLine, selectedDiscountLine);
                }
                this.discountItemsByClient = this.groupItemsByClient(this.discountItems);
            }
            else {
                this.switchDiscountType(0);
            }
        }

        reInitialize(selectedSaleLine?: Model.SaleLine) {
            if (this.selectedSaleLineDiscountIndex > -1) {
                this.discount = _.clone(this.selectedSaleLine.discountLines[this.selectedSaleLineDiscountIndex]);
                this.showEntryFieldType = this.discount.type;
            }
            else {
                this.discount = { type: null, discountValue: 0 };
                this.showEntryFieldType =
                    (this.registerContext.canAddPercentOffDiscount
                        ? Model.DiscountTypeEnum.PercentOff
                        : (this.registerContext.canAddAmountOffDiscount || this.registerContext.canAddSpecificPriceDiscount)
                            ? Model.DiscountTypeEnum.AmountOff
                            : 0); // predefined discount
            }

            if (selectedSaleLine) {
                this.selectedSaleLine = selectedSaleLine;
                this.getPredefinedDiscounts(this.selectedSaleLine);
            }
        }

        isSaleLineBeingCancelled() {
            return this.registerContext.isSaleLineBeingCancelled(this.selectedSaleLine);
        }

        unselectAllSaleItems() {
            // unselect all
            _(this.saleItems).each((item) => {
                item.isSelected = false;
                item.isRequired = false;
            });

            this.totalSelectedQuantity = 0;
            this.totalRequiredQuantity = 0;
            this.totalRequiredAmount = 0;
        }

        selectUnselectAllSaleItems() {
            if (this.shouldSelectAll) {
                this.selectAllSaleItems();
            } else {
                this.unselectAllSaleItems();
            }
        }

        selectAllSaleItemSelection(saleLine?: Model.SaleLine, discountLine?: Model.DiscountLine) {
            if (saleLine) {
                _(this.discountItems).each((saleItem) => {
                    if (saleItem.item === saleLine || (discountLine && discountLine.discountSaleLineGroupId && _(saleItem.item.discountLines).any((dl: Model.DiscountLine) => dl.discountSaleLineGroupId == discountLine.discountSaleLineGroupId))) {
                        if (!saleItem.isSelected) {
                            this.totalSelectedQuantity++;
                        }
                        saleItem.isSelected = true;
                    }
                });
            }
            else if (discountLine && !!discountLine.discountSaleLineGroupId) {
                if (this.discount.isBuyGet) {
                    _(this.buyItems).each((saleItem) => {
                        let discountItem = _(saleItem.item.discountLines).findWhere({ discountSaleLineGroupId: discountLine.discountSaleLineGroupId, isBuyItem: true });
                        if (discountItem) {
                            if (!saleItem.isRequired) {
                                this.totalRequiredQuantity++;
                                this.totalRequiredAmount = this.registerContext.addNormalizedNumbers(this.totalRequiredAmount, saleItem.item.finalItemPrice);
                            }
                            saleItem.isRequired = true;
                        }
                    });
                    this.discountItems = _(this.saleItems).filter((saleItem) => !saleItem.isRequired);
                    this.discountItemsByClient = this.groupItemsByClient(this.discountItems);
                    _(this.discountItems).each((saleItem) => {
                        let discountItem = _(saleItem.item.discountLines).findWhere({ discountSaleLineGroupId: discountLine.discountSaleLineGroupId, isBuyItem: false });
                        if (discountItem) {
                            if (!saleItem.isSelected) {
                                this.totalSelectedQuantity++;
                            }
                            saleItem.isSelected = true;
                        }
                    });
                }
                else {
                    _(this.discountItems).each((saleItem) => {
                        let discountItem = _(saleItem.item.discountLines).findWhere({ discountSaleLineGroupId: discountLine.discountSaleLineGroupId });
                        if (discountItem) {
                            if (!saleItem.isSelected) {
                                this.totalSelectedQuantity++;
                            }
                            saleItem.isSelected = true;
                        }
                    });
                }
            }
        }

        unselectAllPredefinedDiscounts() {
            // unselect all
            _(this.predefinedDiscounts).each((item) => {
                item.isSelected = false;
            });
        }

        selectDiscount(type) {
            if (type == 0 && this.selectedSaleLine == null) {
                this.getPredefinedDiscounts(null, null);
            }

            this.switchDiscountType(type);
        }

        switchDiscountType(type) {
            this.showEntryFieldType = this.discount.type = type;
            this.discount.discountValue = 0;
            this.discount.discountValueSpread = 0;
            this.unselectAllPredefinedDiscounts();
            this.selectedPredefinedDiscounts = null;
            this.unselectAllSaleItems();
            this.saleTypeAllowed = [];
            this.saleTypeRequired = [];
            this.labelOfNumberOfItemsToBeSelected = "";

            if (type !== 0) {
                // manual discount
                this.discount.isBuyGet = false;
                this.discount.discountId = null;
                this.discount.entityId = null;
                this.discount.displayName = null;
                this.discount.isStackable = true; // essential so that we can add multiple manual discounts
                this.discount.saleLineDiscountType = Model.SaleLineDiscountTypeEnum.Manual;
                // pre-select the selectedSaleLine
                this.discountItems = _(this.saleItems).filter((saleItem) => {
                    return !saleItem.item.packageRedeemed;
                });
                this.selectAllSaleItemSelection(this.selectedSaleLine);

                // Toggle Parameters
                this.notPreDefindedDiscountChoosen = true;
            }
            else {
                this.discount.saleLineDiscountType = Model.SaleLineDiscountTypeEnum.Predefined;
                this.focusOnScanBarCode();
            }
            this.discountItemsByClient = this.groupItemsByClient(this.discountItems);
        }

        selectPredefinedDiscount(item) {
            this.notPreDefindedDiscountChoosen = false;
            this.shouldSelectAll = false;
            item.isSelected = !item.isSelected;
            if (item.isSelected) {
                this.selectedPredefinedDiscounts = item;
                // filter out the sale lines based on the selected predefined discount
                //In combination with saleItemsByClientAndSaleType filter, keep in sync with DiscountLogic.IsSaleTypeDiscountTypeMatch
                switch (item.discountEntityType) {
                    case Model.DiscountEntityTypeEnum.Package:
                        this.saleTypeAllowed = [Model.SalesTypeEnum.Package];
                        break;
                    case Model.DiscountEntityTypeEnum.Product:
                        this.saleTypeAllowed = [Model.SalesTypeEnum.Product];
                        break;
                    case Model.DiscountEntityTypeEnum.Service:
                        this.saleTypeAllowed = [Model.SalesTypeEnum.Service, Model.SalesTypeEnum.ServiceCancellationFee, Model.SalesTypeEnum.ServiceNoShowFee, Model.SalesTypeEnum.PackageServiceSwapFee];
                        break;
                    case Model.DiscountEntityTypeEnum.ProductService:
                        this.saleTypeAllowed = [Model.SalesTypeEnum.Product, Model.SalesTypeEnum.Service, Model.SalesTypeEnum.ServiceCancellationFee, Model.SalesTypeEnum.ServiceNoShowFee, Model.SalesTypeEnum.PackageServiceSwapFee];
                        break;
                    case Model.DiscountEntityTypeEnum.Fees:
                        this.saleTypeAllowed = [Model.SalesTypeEnum.PackageServiceSwapFee, Model.SalesTypeEnum.PackageTransfer, Model.SalesTypeEnum.MembershipPayment];
                        break;
                    default:
                        this.saleTypeAllowed = [];
                        break;
                }

                if (item.isBuyGet) {
                    switch (item.buyEntityType) {
                        case Model.DiscountEntityTypeEnum.Package:
                            this.saleTypeRequired = [Model.SalesTypeEnum.Package];
                            break;
                        case Model.DiscountEntityTypeEnum.Product:
                            this.saleTypeRequired = [Model.SalesTypeEnum.Product];
                            break;
                        case Model.DiscountEntityTypeEnum.Service:
                            this.saleTypeRequired = [Model.SalesTypeEnum.Service, Model.SalesTypeEnum.ServiceCancellationFee, Model.SalesTypeEnum.ServiceNoShowFee, Model.SalesTypeEnum.PackageServiceSwapFee];
                            break;
                        case Model.DiscountEntityTypeEnum.ProductService:
                            this.saleTypeRequired = [Model.SalesTypeEnum.Product, Model.SalesTypeEnum.Service, Model.SalesTypeEnum.ServiceCancellationFee, Model.SalesTypeEnum.ServiceNoShowFee, Model.SalesTypeEnum.PackageServiceSwapFee];
                            break;
                        default:
                            this.saleTypeRequired = [];
                            break;
                    }
                }
                else {
                    this.saleTypeRequired = [];
                }
            }

            this.discount.discountId = item.id;
            this.discount.isBuyGet = item.isBuyGet;
            this.discount.isStackable = item.isStackable;
            this.discount.isEmployeeExclusive = item.isEmployeeExclusive || item.details.isEmployeeExclusive;
            this.discount.isFullCommissionApplicable = item.isFullCommissionApplicable || item.details.isFullCommissionApplicable;
            this.discount.isMembershipClientDiscount = item.isMembershipClientDiscount || item.details.isMembershipClientDiscount;
            this.discount.isNonMembershipClientDiscount = item.isNonMembershipClientDiscount || item.details.isNonMembershipClientDiscount;
            this.discount.employees = item.employees || item.details.employees;
            this.discount.clientClientTypes = item.clientClientTypes || item.details.clientClientTypes;
            this.discount.buy_Amount = item.buy_Amount || item.details.buy_Amount;
            this.discount.buy_Quantity = item.buy_Quantity || item.details.buy_Quantity;
            this.discount.get_Quantity = item.get_Quantity || item.details.get_Quantity;
            this.discount.requiredQuantity = item.requiredQuantity || item.details.requiredQuantity;
            this.discount.availableUsageLeft = item.availableUsageLeft || item.details.availableUsageLeft;
            this.discount.isSpread = item.isSpread;
            this.discount.isAllowRedeemBuyGet = item.isAllowRedeemBuyGet;

            if (!this.discount.isBuyGet) {
                if (this.discount.availableUsageLeft) {
                    this.labelOfNumberOfItemsToBeSelected = this.$translate.instant("MESSAGE_DISCOUNTS_SELECT_UPTO_N_ITEMS", {
                        maxNumberOfItems: this.discount.availableUsageLeft * this.discount.requiredQuantity
                    });
                }
                else {
                    this.labelOfNumberOfItemsToBeSelected = this.$translate.instant("MESSAGE_DISCOUNTS_SELECT_MULTIPLES_OF_N_ITEMS", {
                        multipleValue: this.discount.requiredQuantity
                    });
                }
            }

            // deselect the previously selected one
            _(this.predefinedDiscounts).each((predefinedDiscountItem) => {
                if (predefinedDiscountItem !== item) {
                    predefinedDiscountItem.isSelected = false;
                }
            });

            this.unselectAllSaleItems();

            if (this.isEditing && this.selectedPredefinedDiscounts.id == this.origDiscount.discountId) {
                this.selectedPredefinedDiscounts.discountSaleLineGroupId = this.origDiscount.discountSaleLineGroupId;
                this.buyItems = this.discountItems = this.saleItems;
                this.selectAllSaleItemSelection(null, this.selectedPredefinedDiscounts);
            }
            else {
                if (item.isBuyGet) {
                    this.setBuyItems(null);
                }
                else {
                    this.discountItems = this.filterSaleItemsForPredefinedDiscount();
                    this.autoSelectDiscountItem();
                }
            }
            this.discountItemsByClient = this.groupItemsByClient(this.discountItems);
            this.buyItemsByClient = this.groupItemsByClient(this.buyItems);
        }

        private autoSelectDiscountItem() {
            if (this.selectedSaleLine) {
                let matchingDiscountItem = _(this.discountItems).find(discountItem => {
                    return discountItem.item.item.id == this.selectedSaleLine.item.id;
                });
                if (matchingDiscountItem) {
                    matchingDiscountItem.isSelected = true;
                    this.totalSelectedQuantity++;
                }
            }
        }

        filterSaleItemsForPredefinedDiscount(filterOutRequiredItems: boolean = false, clientId: string = null, forBuy: boolean = false) {
            return _(this.saleItems).filter((saleItem) => {
                let discount: Model.IDiscount = _(this.selectedPredefinedDiscounts).findWhere({ id: this.discount.discountId });
                let entityGranularityTypEnum = forBuy ? discount.buy_EntityGranularityTypeEnum : discount.discountEntityGranularityTypeEnum;
                let entityTypEnum = forBuy ? discount.buy_EntityTypeEnum : discount.discountEntityTypeEnum;

                let objectList = null;
                let idToLookFor = saleItem.item.item.id; // will get updated for Package, Membership or Gift Card

                switch (entityTypEnum) {
                    case Meevo.Model.DiscountEntityTypeEnum.Service:
                        if (saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.Service
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.ServiceCancellationFee
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.ServiceNoShowFee
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.PackageServiceSwapFee) {
                            return false;
                        }
                        if (entityGranularityTypEnum === Meevo.Model.DiscountEntityGranularityTypeEnum.Specific) {
                            objectList = forBuy ? discount.buy_Services : discount.services;
                        }
                        break;

                    case Meevo.Model.DiscountEntityTypeEnum.Product:
                        if (saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.Product) {
                            return false;
                        }
                        if (entityGranularityTypEnum === Meevo.Model.DiscountEntityGranularityTypeEnum.Specific) {
                            objectList = forBuy ? discount.buy_ProductVariants : discount.productVariants;
                        }
                        break;

                    case Meevo.Model.DiscountEntityTypeEnum.ProductService:
                        if (saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.Service
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.ServiceCancellationFee
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.ServiceNoShowFee
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.PackageServiceSwapFee
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.Product) {
                            return false;
                        }
                        break;

                    case Meevo.Model.DiscountEntityTypeEnum.Package:
                        if (saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.Package) {
                            return false;
                        }
                        idToLookFor = saleItem.item.item.clientPackage.packageTypeId;
                        if (entityGranularityTypEnum === Meevo.Model.DiscountEntityGranularityTypeEnum.Specific) {
                            objectList = forBuy ? discount.buy_PackageTypes : discount.packageTypes;
                        }
                        break;

                    case Meevo.Model.DiscountEntityTypeEnum.Membership:
                        if (saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.Membership) {
                            return false;
                        }
                        idToLookFor = saleItem.item.item.membershipId;
                        if (entityGranularityTypEnum === Meevo.Model.DiscountEntityGranularityTypeEnum.Specific) {
                            objectList = forBuy ? discount.buy_Memberships : discount.memberships;
                        }
                        break;

                    case Meevo.Model.DiscountEntityTypeEnum.GiftCard:
                        if (saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.GiftCard) {
                            return false;
                        }
                        idToLookFor = saleItem.item.item.clientGiftCard.giftCardTypeId;
                        if (entityGranularityTypEnum === Meevo.Model.DiscountEntityGranularityTypeEnum.Specific) {
                            objectList = forBuy ? discount.buy_GiftCardTypes : discount.giftCardTypes;
                        }
                        break;

                    case Meevo.Model.DiscountEntityTypeEnum.RebookedAppointments:
                        if (saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.Service
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.ServiceCancellationFee
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.ServiceNoShowFee
                            && saleItem.item.saleType !== Meevo.Model.SalesTypeEnum.PackageServiceSwapFee) {
                            return false;
                        }
                        if (!saleItem.item.item.isRebooked) {
                            return false;
                        }
                        if (entityGranularityTypEnum === Meevo.Model.DiscountEntityGranularityTypeEnum.Specific) {
                            objectList = forBuy ? discount.buy_Services : discount.services;
                        }
                        break;
                }

                if (objectList != null) {
                    let item = _(objectList).findWhere({ id: idToLookFor });
                    if (item == null) {
                        return false;
                    }
                }

                return this.isFilter(filterOutRequiredItems, saleItem, clientId);
            });
        }

        private isFilter(filterOutRequiredItems: boolean, saleItem, clientId: string) {
            // TODO: this should be broken up into separate statements

            let isFilter = (!filterOutRequiredItems || !saleItem.isRequired)

            && (filterOutRequiredItems ? !saleItem.item.packageRedeemed : (!saleItem.item.packageRedeemed || this.discount.isAllowRedeemBuyGet))

            && (clientId == null || clientId == saleItem.item.clientId)

            && (!this.selectedPredefinedDiscounts.details.isRedeemableLimitApplicable
                || this.selectedPredefinedDiscounts.details.discountRedeemableLimitPerTypeEnum !== Model.DiscountRedeemableLimitPerTypeEnum.Client
                || (this.selectedPredefinedDiscounts.details.discountRedeemableLimitPerTypeEnum === Model.DiscountRedeemableLimitPerTypeEnum.Client
                    && saleItem.item.clientType === Model.ClientTypeEnum.Client
                    && saleItem.item.clientId != null
                    && !Guid.empty.equals(new Guid(saleItem.item.clientId))
                )
            )

            && (!this.discount.isEmployeeExclusive
                || (saleItem.item.clientType === Model.ClientTypeEnum.Client && this.discount.isEmployeeExclusive == saleItem.item.client.isEmployee)
            )

            && (this.discount.isEmployeeExclusive
                || (!this.discount.isMembershipClientDiscount && !this.discount.isNonMembershipClientDiscount)
                || (this.discount.isMembershipClientDiscount && this.discount.isNonMembershipClientDiscount)
                || (this.discount.isMembershipClientDiscount
                    && saleItem.item.clientType === Model.ClientTypeEnum.Client
                    && saleItem.item.client.clientMembershipId
                    && !Guid.empty.equals(saleItem.item.client.clientMembershipId)
                    && saleItem.item.client.membershipStatus === Model.ClientMembershipStatusEnum.Active
                )
                || (this.discount.isNonMembershipClientDiscount
                    && (saleItem.item.clientType !== Model.ClientTypeEnum.Client
                        || !saleItem.item.client.clientMembershipId
                        || Guid.empty.equals(saleItem.item.client.clientMembershipId)
                        || saleItem.item.client.membershipStatus !== Model.ClientMembershipStatusEnum.Active
                    )
                )
            )

            && (this.discount.employees.length === 0
                || _(this.discount.employees).find((employee) =>
                    employee.id == saleItem.item.employeeId || employee.id == saleItem.item.secondEmployeeId)
            )

            && (this.discount.clientClientTypes.length == 0
                || _(this.discount.clientClientTypes).find((clientType) =>
                    saleItem.item.clientType === Model.ClientTypeEnum.Client && _.contains(saleItem.item.client.clientClientTypeIds, clientType.id))
            )

            && !_(saleItem.item.discountLines).find((discountLine: Model.DiscountLine) =>
                discountLine.discountId == this.discount.discountId)

            return isFilter;
        }

        selectAllSaleItems() {
            _(this.discountItems).each((item) => {
                if ((item.item.saleType !== Model.SalesTypeEnum.GiftCard && item.item.saleType !== Model.SalesTypeEnum.ReloadGiftCard && item.item.saleType !== Model.SalesTypeEnum.Membership && item.item.saleType !== Model.SalesTypeEnum.MembershipRenewal)
                    || ((item.item.saleType === Model.SalesTypeEnum.GiftCard || item.item.saleType === Model.SalesTypeEnum.ReloadGiftCard) && this.registerContext.applyDiscountGiftCardPermission)
                    || ((item.item.saleType === Model.SalesTypeEnum.Membership || item.item.saleType === Model.SalesTypeEnum.MembershipRenewal) && this.registerContext.applyDiscountMembershipPermission)
                ) {
                    if (!item.isSelected) {
                        this.totalSelectedQuantity++;
                    }
                    item.isSelected = true;
                }
            });
        }

        selectSaleItem(saleItem) {
            if (saleItem.isRequired) {
                return;
            }

            if (this.discount.type !== 0 || this.canSelectGetItem(saleItem) || saleItem.isSelected) {
                // TODO: Do we still need to stop deselecting when editing?
                if (!this.isEditing || (this.selectedSaleLine && saleItem.item !== this.selectedSaleLine)) {
                    saleItem.isSelected = !saleItem.isSelected;
                    if (saleItem.isSelected) {
                        this.totalSelectedQuantity++;
                    }
                    else {
                        this.totalSelectedQuantity--;
                    }
                }
            }
        }

        requireSaleItem(saleItem) {
            if (this.discount.type !== 0 || !this.discount.isBuyGet || this.canSelectBuyItem() || saleItem.isRequired) {
                saleItem.isRequired = !saleItem.isRequired;

                if (saleItem.isRequired) {
                    this.totalRequiredQuantity++;
                    this.totalRequiredAmount = this.registerContext.addNormalizedNumbers(this.totalRequiredAmount, saleItem.item.finalItemPrice);
                }
                else {
                    this.totalRequiredQuantity--;
                    this.totalRequiredAmount = this.registerContext.subtractNormalizedNumbers(this.totalRequiredAmount, saleItem.item.finalItemPrice);
                }

                if (saleItem.isSelected) {
                    // cannot have the same item as buy item and get item
                    saleItem.isSelected = false;
                    this.totalSelectedQuantity--;
                }
            }

            let clientId = null;
            if (this.discount.type === 0
                && this.selectedPredefinedDiscounts.details.isRedeemableLimitApplicable
                && this.selectedPredefinedDiscounts.details.discountRedeemableLimitPerTypeEnum == Model.DiscountRedeemableLimitPerTypeEnum.Client) {
                if (this.totalRequiredQuantity > 0) {
                    clientId = (saleItem.isRequired)
                        ? saleItem.item.clientId
                        : _(this.buyItems).findWhere({ isRequired: true }).item.clientId;

                    this.setBuyItems(clientId);
                }
                else if (this.totalRequiredQuantity == 0) {
                    this.setBuyItems(null);
                    _(this.saleItems).each((item) => item.isSelected = false);
                    this.totalSelectedQuantity = 0;
                }

                this.buyItemsByClient = this.groupItemsByClient(this.buyItems);
            }

            if (this.discount.type === 0 && this.hasMetRequirement()) {
                this.discountItems = this.filterSaleItemsForPredefinedDiscount(true, clientId);
                this.discountItemsByClient = this.groupItemsByClient(this.discountItems);
                this.autoSelectDiscountItem();
            }
        }

        setBuyItems(clientId) {
            this.buyItems = this.filterSaleItemsForPredefinedDiscount(false, clientId, true);
        }

        canSelectGetItem(saleItem) {
            if (this.discount.type !== 0) {
                return true;
            }

            if (this.selectedPredefinedDiscounts.isBuyGet) {
                return (this.totalSelectedQuantity < this.selectedPredefinedDiscounts.details.get_Quantity
                    || this.selectedPredefinedDiscounts.details.get_Quantity === 0);
            }
            else {
                if (this.selectedPredefinedDiscounts.details.isRedeemableLimitApplicable
                    && this.selectedPredefinedDiscounts.availableUsageLeft >= 0 // if availableUsageLeft == 0, it should not show up here
                    && this.selectedPredefinedDiscounts.details.requiredQuantity > 0) {
                    // everything listed should be selectable
                    if (this.selectedPredefinedDiscounts.details.isSpread &&
                        this.selectedPredefinedDiscounts.details.requiredQuantity === 1) {
                        return true;
                    }

                    let totalSelectedQuantity = this.totalSelectedQuantity;
                    if (this.selectedPredefinedDiscounts.details.discountRedeemableLimitPerTypeEnum === Model.DiscountRedeemableLimitPerTypeEnum.Client) {
                        totalSelectedQuantity = _.chain(this.discountItems).where({ isSelected: true }).pluck("item").where({ clientId: saleItem.item.clientId }).value().length;
                    }
                    let nUsage = totalSelectedQuantity / this.selectedPredefinedDiscounts.details.requiredQuantity;
                    return nUsage < this.selectedPredefinedDiscounts.availableUsageLeft;
                }
                else {
                    return true;
                }
            }
        }

        canSelectBuyItem() {
            if (this.discount.type !== 0 || !this.selectedPredefinedDiscounts.isBuyGet) {
                return true;
            }

            switch (this.selectedPredefinedDiscounts.bogoBasedOnType) {
                case Meevo.Model.DiscountBasedOnEnum.Quantity:
                    return (this.totalRequiredQuantity < this.selectedPredefinedDiscounts.details.buy_Quantity
                        || this.selectedPredefinedDiscounts.details.buy_Quantity === 0);

                case Meevo.Model.DiscountBasedOnEnum.Amount:
                    return (this.totalRequiredAmount < this.selectedPredefinedDiscounts.details.buy_Amount
                        || this.selectedPredefinedDiscounts.details.buy_Amount === 0);
            }

            return true;
        }

        isRequiredQuantitySatisfied() {
            return this.totalRequiredQuantity >= this.selectedPredefinedDiscounts.details.buy_Quantity && this.totalRequiredQuantity > 0;
        }

        isRequiredAmountSatisfied() {
            return this.totalRequiredAmount >= this.selectedPredefinedDiscounts.details.buy_Amount && this.totalRequiredAmount > 0;
        }

        isSelectedQuantitySatisfied() {
            return this.totalSelectedQuantity >= this.selectedPredefinedDiscounts.details.get_Quantity && this.totalSelectedQuantity > 0;
        }

        hasMetRequirement() {
            if (this.discount.type !== 0 || !this.selectedPredefinedDiscounts.isBuyGet) {
                return true;
            }

            switch (this.selectedPredefinedDiscounts.bogoBasedOnType) {
                case Meevo.Model.DiscountBasedOnEnum.Quantity:
                    return this.isRequiredQuantitySatisfied();

                case Meevo.Model.DiscountBasedOnEnum.Amount:
                    return this.isRequiredAmountSatisfied();
            }

            return true;
        }

        hasMetAllQuantityRequirements() {
            // not a predefined discount
            if (this.discount.type !== 0) {
                return (this.totalSelectedQuantity > 0);
            }

            if (!this.selectedPredefinedDiscounts) {
                return false;
            }

            // BOGO predefined discount
            if (this.selectedPredefinedDiscounts.isBuyGet) {
                switch (this.selectedPredefinedDiscounts.bogoBasedOnType) {
                    case Meevo.Model.DiscountBasedOnEnum.Quantity:
                        return this.isSelectedQuantitySatisfied() && this.isRequiredQuantitySatisfied();

                    case Meevo.Model.DiscountBasedOnEnum.Amount:
                        return this.isSelectedQuantitySatisfied() && this.isRequiredAmountSatisfied();
                }
            }

            // non-BOGO predefined discount
            return (this.totalSelectedQuantity > 0
                && (this.selectedPredefinedDiscounts.details.requiredQuantity == 0
                    || (this.totalSelectedQuantity % this.selectedPredefinedDiscounts.details.requiredQuantity) == 0));
        }

        private isDiscount(discount): boolean {
            return (
                discount.saleLineDiscountType !== Model.SaleLineDiscountTypeEnum.ItemOnSale &&
                discount.saleLineDiscountType !== Model.SaleLineDiscountTypeEnum.CancellationFee &&
                discount.saleLineDiscountType !== Model.SaleLineDiscountTypeEnum.NoShowFee
            );
        }

        private hasAtLeastOneDiscount(): boolean {
            for (let index = 0; index < this.saleItems.length; index++) {
                let saleItem = this.saleItems[index];

                if (saleItem.isSelected || saleItem.isRequired) {
                    if (saleItem.item.discountLines &&
                        _(saleItem.item.discountLines).any((discountLine: Model.DiscountLine) => this.isDiscount(discountLine))) {
                        return true;
                    }
                }
            }
        }

        private hasDiscountsNotStackable(): boolean {
            // check if the selected sale items have discounts that cannot be combined with other discounts
            // except Yield Management stackable which still allows manual discounts
            for (let index = 0; index < this.saleItems.length; index++) {
                let saleItem = this.saleItems[index];

                if (saleItem.isSelected || saleItem.isRequired) {
                    const isNotStackable = _.chain(saleItem.item.discountLines)
                        .filter(dl => dl.saleLineDiscountType !== Meevo.Model.SaleLineDiscountTypeEnum.YieldManagement)
                        .any(dl => !dl.isStackable)
                        .value();

                    if (isNotStackable) {
                        return true;
                    }
                }
            }
        }

        private hasNonStackableItemOnSale(): boolean {
            for (let index = 0; index < this.saleItems.length; index++) {
                let saleItem = this.saleItems[index];

                if (saleItem.isSelected || saleItem.isRequired) {
                    if (_(saleItem.item.discountLines).any((dl: Meevo.Model.DiscountLine) =>
                        dl.saleLineDiscountType === Meevo.Model.SaleLineDiscountTypeEnum.ItemOnSale &&
                        !dl.isStackable)) {
                        return true;
                    }
                }
            }
        }

        validateDiscountBeforeApply(isValid) {
            let goToTicket = false;

            if ((device.mobile() || (!this.registerContext.$scope.isLargeTablet && !device.desktop())) && device.portrait()) {
                goToTicket = true;
            }

            let asked = false;

            let validateAtLeastOneDiscount = () => {
                if (asked) {
                    return asked;
                }

                // check if the selected discount cannot be combined with other discounts
                if (this.discount.type === 0) {
                    let prefDiscountItem: any = _(this.predefinedDiscounts).findWhere({ isSelected: true });
                    if (prefDiscountItem && !prefDiscountItem.details.isStackable) {
                        if (this.hasAtLeastOneDiscount()) {
                            asked = true;
                            this.modalService
                                .confirm("MESSAGE_APPLYING_A_DISCOUNT_THAT_CANNOT_BE_COMBINED")
                                .then(() => {
                                    var isItemOnSaleOverride = !!this.saleItems.find(saleItem => saleItem.isSelected && 
                                        !!saleItem.item.discountLines.find(discount => discount.isItemOnSaleOverride));
                                    this.applyDiscount(isValid, goToTicket, isItemOnSaleOverride);
                                });
                        }
                    }
                }
            }

            let validateDiscountsNotStackable = () => {
                if (this.hasDiscountsNotStackable()) {
                    asked = true;

                    let hasNonStackableItemOnSale = this.hasNonStackableItemOnSale();

                    if (hasNonStackableItemOnSale &&
                        this.securityReplaceItemOnSale === Meevo.Model.SecurityAccessEnum.Hide) {
                        this.modalService.alert("MESSAGE_ITEM_FOR_SALE_CANNOT_BE_REPLACED");
                        return;
                    }

                    const userOptions = hasNonStackableItemOnSale
                        ? {
                            okButtonSecurityKey: this.meevoSecurityKeys.REGISTER_REGISTER_DISCOUNT_REPLACEITEMONSALE
                        }
                        : undefined;

                    this.modalService
                        .confirm("MESSAGE_APPLYING_A_DISCOUNT_OVER_DISCOUNT_THAT_CANNOT_BE_COMBINED",
                            Components.Modal.ModalTranslationModes.Translate,
                            true,
                            userOptions)
                        .then((result) => {
                            for (let index = 0; index < this.saleItems.length; index++) {
                                let saleItem = this.saleItems[index];
                                if (saleItem.isSelected || saleItem.isRequired) {
                                    if (_(saleItem.item.discountLines).findWhere({ isStackable: false })) {
                                        const removedDiscountLines = this.removeDiscounts(saleItem.item);
                                        //Add auto discount ids to exclusion list so they're not not re-applied on server
                                        let autoDiscountIdsToRemove = _(removedDiscountLines)
                                            .chain()
                                            .filter(discountLine => discountLine.isAutoApply)
                                            .pluck("discountId")
                                            .value();
                                        this.registerContext.sale.removedAutomaticDiscountIds =
                                            Array.from(new Set([...this.registerContext.sale.removedAutomaticDiscountIds, ...autoDiscountIdsToRemove]));
                                    }
                                }
                            }

                            this.applyDiscount(isValid, goToTicket, hasNonStackableItemOnSale);
                        });
                }
            }

            function adjustGiftCardValue(saleLine, newFinalItemPrice: number) {
                saleLine.baseItemPrice =
                    saleLine.originalFinalItemPrice =
                    saleLine.item.clientGiftCard.remainingAmount = newFinalItemPrice;
            }

            let validateGiftCardDiscounts = () => {
                if (this.discount.type !== Meevo.Model.DiscountTypeEnum.SpecialPrice) {
                    return;
                }

                const newFinalItemPrice = this.discount.discountValue;
                let saleItemsToAdjust = [];

                for (const saleItem of this.saleItems) {
                    if (!saleItem.isSelected) {
                        continue;
                    }
                    
                    const saleLine = saleItem.item;

                    if (saleLine.saleType !== Meevo.Model.SalesTypeEnum.GiftCard) {
                        continue;
                    }

                    if (newFinalItemPrice >= saleLine.item.clientGiftCard.remainingAmount) {
                        saleItem.isSelected = false;
                        adjustGiftCardValue(saleLine, newFinalItemPrice);
                        this.registerContext.registerDiscountService.handlePriceChangeDiscount(this.registerContext, saleLine, newFinalItemPrice, 0);
                    } else {
                        saleItemsToAdjust.push(saleItem);
                    }
                }

                if (saleItemsToAdjust.length > 0) {
                    asked = true;

                    const meevoCurrency = this.$filter("meevoCurrency") as any;
                    const formattedPrice = meevoCurrency(newFinalItemPrice);
                    const message = this.$translate.instant("MESSAGE_REDUCE_GIFT_CARD_VALUE", { price: formattedPrice });
    
                    this.modalService.confirm(message)
                        .then(() => {
                            for (const saleItem of saleItemsToAdjust) {
                                const saleLine = saleItem.item;
                                saleItem.isSelected = false;
                                adjustGiftCardValue(saleLine, newFinalItemPrice);
                                this.registerContext.registerDiscountService.handlePriceChangeDiscount(this.registerContext, saleLine, newFinalItemPrice, 0);
                            }
                        })
                        .finally(() => {
                            this.applyDiscount(isValid, goToTicket);
                        });
                }
            }

            validateAtLeastOneDiscount();

            if (!asked) {
                validateDiscountsNotStackable();
            }

            if (!asked) {
                validateGiftCardDiscounts();
            }

            if (!asked) {
                this.applyDiscount(isValid, goToTicket);
            }
        }

        applyDiscount(isValid, goToTicket, isItemOnSaleOverride = false) {
            let selectedDiscount: Model.DiscountLine, requiredDiscount: Model.DiscountLine;

            if (this.discount.type === 0) {
                let prefDiscountItem = _(this.predefinedDiscounts).findWhere({ isSelected: true });
                if (prefDiscountItem) {
                    selectedDiscount = {
                        discountId: prefDiscountItem.id
                        , displayName: prefDiscountItem.displayName
                        , isStackable: prefDiscountItem.details.isStackable
                        , isEmployeeExclusive: prefDiscountItem.details.isEmployeeExclusive
                        , isBuyGet: prefDiscountItem.details.isBuyGet
                        , isFullCommissionApplicable: prefDiscountItem.details.isFullCommissionApplicable
                        , buyEntityType: prefDiscountItem.buyEntityType
                        , discountEntityType: prefDiscountItem.discountEntityType
                        , discountSaleLineGroupId: this.discount ? (this.discount.discountSaleLineGroupId || Guid.newGuid().toString()) : Guid.newGuid().toString()
                        , entityId: prefDiscountItem.id
                        , employees: prefDiscountItem.details.employees
                        , clientClientTypes: prefDiscountItem.details.clientClientTypes
                        , buy_Amount: prefDiscountItem.details.buy_Amount
                        , buy_Quantity: prefDiscountItem.details.buy_Quantity
                        , get_Quantity: prefDiscountItem.details.get_Quantity
                        , requiredQuantity: prefDiscountItem.details.requiredQuantity
                        , showPoleMessage: this.isEditing ? Model.SaleLineStatusEnum.Updated : Model.SaleLineStatusEnum.Added
                        , isSpread: prefDiscountItem.details.isSpread
                        , isAllowRedeemBuyGet: prefDiscountItem.details.isAllowRedeemBuyGet
                        , isItemOnSaleOverride: isItemOnSaleOverride
                    };
                }

                if (prefDiscountItem.isBuyGet) {
                    requiredDiscount = _.clone(selectedDiscount);
                    requiredDiscount.isBuyItem = true;
                    requiredDiscount.isItemOnSaleOverride = isItemOnSaleOverride;
                }
            }
            else {
                selectedDiscount = _.clone(this.discount);

                selectedDiscount.discountSaleLineGroupId = selectedDiscount.discountSaleLineGroupId || Guid.newGuid().toString();
                selectedDiscount.showPoleMessage = this.isEditing ? Model.SaleLineStatusEnum.Updated : Model.SaleLineStatusEnum.Added;
                selectedDiscount.isItemOnSaleOverride = isItemOnSaleOverride;
            }

            // if form is not valid or no discount type selected or no sale items selected, do nothing
            if (!isValid || selectedDiscount == null || !this.hasMetAllQuantityRequirements()) {
                return;
            }

            _(this.saleItems).each((saleItem) => {
                if (saleItem.isSelected) {
                    if (!saleItem.item.quantitySelected) {
                        saleItem.item.quantitySelected = 0;
                    }
                    saleItem.item.quantitySelected++;
                }

                if (saleItem.isRequired) {
                    if (!saleItem.item.quantityRequired) {
                        saleItem.item.quantityRequired = 0;
                    }
                    saleItem.item.quantityRequired++;
                }
            });

            if (selectedDiscount) {
                let numApplied = 0;
                for (let ndx = 0; ndx < this.registerContext.sale.saleLines.length; ndx++) {
                    let saleLineDiscountIndex;
                    let saleLine = this.registerContext.sale.saleLines[ndx];

                    let originalDiscountLines = angular.copy(saleLine.discountLines);

                    if (this.isEditing) {
                        let discountToRemove = _(saleLine.discountLines).findWhere({ discountSaleLineGroupId: selectedDiscount.discountSaleLineGroupId });
                        if (discountToRemove) {
                            saleLineDiscountIndex = saleLine.discountLines.indexOf(discountToRemove);
                            saleLine.discountLines.splice(saleLineDiscountIndex, 1);
                        }
                    }

                    let countSelected = saleLine.quantitySelected;
                    if (countSelected && countSelected > 0) {
                        if (countSelected < saleLine.quantity) {
                            let splitSaleLine = this.registerContext.splitSaleLine(saleLine, countSelected);
                            splitSaleLine.quantitySelected = 0;
                        }

                        if (!saleLine.discountLines) {
                            saleLine.discountLines = [];
                        }

                        if (!selectedDiscount.isStackable) {
                            this.removeDiscounts(saleLine);
                        }

                        if (selectedDiscount.discountId == null || !_(saleLine.discountLines).findWhere({ discountId: selectedDiscount.discountId })) {
                            if (this.isEditing && angular.isDefined(saleLineDiscountIndex)) {
                                // insert the new discount line
                                saleLine.discountLines.splice(saleLineDiscountIndex, 0, selectedDiscount);
                            }
                            else {
                                let appendDiscount = true;
                                if (selectedDiscount.type === Model.DiscountTypeEnum.SpecialPrice
                                    && (selectedDiscount.discountId == null || Guid.empty.equals(new Guid(selectedDiscount.discountId)))) {
                                    let lastDiscount: any = _.last(saleLine.discountLines);
                                    if (lastDiscount
                                        && lastDiscount.type === Model.DiscountTypeEnum.SpecialPrice
                                        && (lastDiscount.discountId == null || Guid.empty.equals(new Guid(lastDiscount.discountId)))) {
                                        lastDiscount.discountValue = selectedDiscount.discountValue;
                                        lastDiscount.isSpread = selectedDiscount.isSpread;
                                        lastDiscount.discountSaleLineGroupId = selectedDiscount.discountSaleLineGroupId;
                                        appendDiscount = false;
                                    }
                                }

                                if (appendDiscount) {
                                    let cancellationFeeIndex = -1;
                                    // if selectedDiscount is a predefind discount, find if there is a cancellation fee on the sale line and insert this discount before that
                                    if (selectedDiscount.discountId != null && !Guid.empty.equals(new Guid(selectedDiscount.discountId))) {
                                        cancellationFeeIndex = _.findIndex(saleLine.discountLines, (discountLine: Model.DiscountLine) =>
                                            discountLine.saleLineDiscountType === Model.SaleLineDiscountTypeEnum.CancellationFee ||
                                            discountLine.saleLineDiscountType === Model.SaleLineDiscountTypeEnum.NoShowFee
                                        );
                                    }

                                    if (cancellationFeeIndex >= 0) {
                                        saleLine.discountLines.splice(cancellationFeeIndex, 0, selectedDiscount);
                                    }
                                    else {
                                        saleLine.discountLines.push(selectedDiscount);
                                    }
                                    numApplied += countSelected;
                                }
                            }
                            this.updateSaleLineFullCommissionValue(saleLine, selectedDiscount);
                        }

                        saleLine.quantitySelected = 0;
                        saleLine.quantityRequired = 0;
                    }

                    // check for multiples; change group id for every multiple
                    if (!this.isEditing && !selectedDiscount.isBuyGet &&
                        numApplied == selectedDiscount.requiredQuantity &&
                        (!selectedDiscount.isSpread || (selectedDiscount.isSpread && selectedDiscount.requiredQuantity > 1))) {
                        selectedDiscount = angular.copy(selectedDiscount);
                        selectedDiscount.discountSaleLineGroupId = Guid.newGuid().toString();
                        numApplied = 0;
                    }

                    if (selectedDiscount.isBuyGet) {
                        let countRequired = saleLine.quantityRequired;
                        if (countRequired && countRequired > 0) {
                            if (countRequired < saleLine.quantity) {
                                let splitSaleLine = this.registerContext.splitSaleLine(saleLine, countRequired);
                                splitSaleLine.quantityRequired = 0;
                            }

                            if (this.hasAtLeastOneDiscount()) {
                                this.removeDiscounts(saleLine);
                            }

                            if (requiredDiscount.discountId != null && !_(saleLine.discountLines).findWhere({ discountId: requiredDiscount.discountId })) {
                                if (this.isEditing && saleLine === this.selectedSaleLine) {
                                    // insert the new discount line
                                    saleLine.discountLines.splice(this.selectedSaleLineDiscountIndex, 0, requiredDiscount);
                                }
                                else {
                                    saleLine.discountLines.push(requiredDiscount);
                                }
                            }

                            saleLine.quantityRequired = 0;
                            saleLine.quantitySelected = 0;
                        }
                    }

                    // remove redemptions for this package when updating discounts
                    if (!angular.equals(originalDiscountLines, saleLine.discountLines)) {
                        if (this.registerContext.isPackageType(saleLine)) {
                            this.registerContext.removeRedemptionForPackage(saleLine.item.id);
                        }
                    }
                }
            }

            this.deCircularReferenceSpreads();
            this.registerContext.recalculateSale(true);

            //mobile device -> navigate to ticket
            if (goToTicket) {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Ticket);
            } else {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
            }
        }

        deCircularReferenceSpreads() {
            if (this.isEditing && this.discount.isSpread) {
                let selectedItems = _(this.discountItems).where({ isSelected: true });
                selectedItems.forEach(selectedItem => {
                    var currentSpreadIndex = _.findIndex(selectedItem.item.discountLines, (discountLine: any) => discountLine.discountSaleLineGroupId === this.discount.discountSaleLineGroupId);

                    let followingSpreads = [];
                    for (var i = currentSpreadIndex + 1; i <= selectedItem.item.discountLines.length - 1; i++) {
                        let discountLine = selectedItem.item.discountLines[i];
                        if (discountLine.isSpread) {
                            followingSpreads.push({ index: i, discountLine });
                        }
                    }

                    while (followingSpreads.length > 0) {
                        let followingSpread = followingSpreads[0];
                        if (this.isSpreadFoundPrior(selectedItem, selectedItems, followingSpread.discountLine.discountSaleLineGroupId)) {
                            // move it before discount being edited
                            selectedItem.item.discountLines.splice(followingSpread.index, 1);
                            selectedItem.item.discountLines.splice(currentSpreadIndex, 0, followingSpread.discountLine);
                        }
                        followingSpreads.splice(0, 1);
                    }
                });
            }
        }

        isSpreadFoundPrior(currentItem, selectedItems, spreadIdToCheck) {
            for (let selectedItem of selectedItems) {
                if (selectedItem === currentItem) {
                    continue;
                }
                var currentSpreadIndex = _.findIndex(selectedItem.item.discountLines, (discountLine:any) => discountLine.discountSaleLineGroupId === this.discount.discountSaleLineGroupId);
                var spreadIdToCheckIndex = _.findIndex(selectedItem.item.discountLines, (discountLine: any) => discountLine.discountSaleLineGroupId === spreadIdToCheck);

                if (spreadIdToCheckIndex < currentSpreadIndex) {
                    return true;
                }
            }
            return false;
        }

        getPredefinedDiscounts(selectedSaleLine: Model.SaleLine, selectedDiscountLine?: Model.DiscountLine) {
            this.performedPredefinedDiscountSearch = false;
            let request: any = this.registerContext.sale;
            request.selectedSaleLine = selectedSaleLine;
            this.dataService
                .customMethodData("api/sale/discount/list", "POST", request)
                .then((response) => {
                    this.predefinedDiscounts = response.data;
                    if (selectedDiscountLine && !!selectedDiscountLine.discountId) {
                        let predefinedSelectedDiscount = _(this.predefinedDiscounts).findWhere({ id: selectedDiscountLine.discountId });
                        if (predefinedSelectedDiscount) {
                            predefinedSelectedDiscount.isSelected = true;
                        }
                        else {
                            predefinedSelectedDiscount = {
                                id: selectedDiscountLine.discountId,
                                displayName: selectedDiscountLine.displayName,
                                buyEntityType: selectedDiscountLine.buyEntityType,
                                discountEntityType: selectedDiscountLine.discountEntityType,
                                isBuyGet: selectedDiscountLine.isBuyGet,
                                isStackable: selectedDiscountLine.isStackable,
                                isEmployeeExclusive: selectedDiscountLine.isEmployeeExclusive,
                                isFullCommissionApplicable: selectedDiscountLine.isFullCommissionApplicable,
                                isMembershipClientDiscount: selectedDiscountLine.isMembershipClientDiscount,
                                isNonMembershipClientDiscount: selectedDiscountLine.isNonMembershipClientDiscount,
                                isSelected: true,
                                isOriginalDiscount: true,
                                discountSaleLineGroupId: selectedDiscountLine.discountSaleLineGroupId,
                                entityId: selectedDiscountLine.discountId,
                                employees: selectedDiscountLine.employees,
                                clientClientTypes: selectedDiscountLine.clientClientTypes,
                                buy_Amount: selectedDiscountLine.buy_Amount,
                                buy_Quantity: selectedDiscountLine.buy_Quantity,
                                get_Quantity: selectedDiscountLine.get_Quantity,
                                requiredQuantity: selectedDiscountLine.requiredQuantity,
                                details: {
                                    isStackable: selectedDiscountLine.isStackable
                                    , isEmployeeExclusive: selectedDiscountLine.isEmployeeExclusive
                                    , isBuyGet: selectedDiscountLine.isBuyGet
                                    , isFullCommissionApplicable: selectedDiscountLine.isFullCommissionApplicable
                                    , isMembershipClientDiscount: selectedDiscountLine.isMembershipClientDiscount
                                    , isNonMembershipClientDiscount: selectedDiscountLine.isNonMembershipClientDiscount
                                    , employees: selectedDiscountLine.employees
                                    , clientClientTypes: selectedDiscountLine.clientClientTypes
                                    , get_Quantity: selectedDiscountLine.get_Quantity
                                    , buy_Amount: selectedDiscountLine.buy_Amount
                                    , buy_Quantity: selectedDiscountLine.buy_Quantity
                                    , requiredQuantity: selectedDiscountLine.requiredQuantity
                                    , isSpread: selectedDiscountLine.isSpread
                                    , isAllowRedeemBuyGet: selectedDiscountLine.isAllowRedeemBuyGet
                                }
                            };
                            this.predefinedDiscounts.push(predefinedSelectedDiscount);
                        }
                        this.selectedPredefinedDiscounts = predefinedSelectedDiscount;
                    }
                })
                .finally(() => {
                    this.performedPredefinedDiscountSearch = true;
                });
        }

        canShowEntryField() {
            return (this.discount.type != null);
        }

        canShowBuyItems() {
            return (this.canShowEntryField() && this.discount.type === 0 && this.discount.isBuyGet && _(this.predefinedDiscounts).any(item => item.isSelected));
        }

        canShowSaleItems() {
            return (this.canShowEntryField()
                && (this.discount.type !== 0
                    || (_(this.predefinedDiscounts).any(item => item.isSelected) && this.hasMetRequirement()))
            );
        }

        cancel() {
            this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
        }

        updateSaleLineFullCommissionValue(saleLine: Model.SaleLine, discount: Model.DiscountLine) {
            if (discount.isFullCommissionApplicable) {
                saleLine.isFullCommissionApplicable = discount.isFullCommissionApplicable;
                saleLine.isFullCommissionApplicableManuallyChecked = null;
            }
        }

        isPercentOffVisible() {
            return this.isPercentOff(this.showEntryFieldType);
        }

        isPercentOff(field) {
            field = field || this.discount.type;
            return field === Model.DiscountTypeEnum.PercentOff;
        }

        isAmountOffVisible() {
            return this.isAmountOff(this.showEntryFieldType);
        }

        isAmountOff(field) {
            field = field || this.discount.type;
            return field === Model.DiscountTypeEnum.AmountOff;
        }

        isSpecificPriceVisible() {
            return this.isSpecificPrice(this.showEntryFieldType);
        }

        isSpecificPrice(field) {
            field = field || this.discount.type;
            return field === Model.DiscountTypeEnum.SpecialPrice;
        }

        isPredefinedVisible() {
            return this.isPredefined(this.showEntryFieldType);
        }

        isPredefined(field) {
            field = field || this.discount.type;
            return field === 0;
        }

        isSelectAllVisible() {
            return !this.isPredefined(undefined)
                || (!this.discount.availableUsageLeft && this.discount.requiredQuantity === 1);
        }

        isSpreadSpecificPriceVisible() {
            return this.isSpecificPriceVisible() && this.discount.isSpread;
        }

        isNonSpreadSpecificPriceVisible() {
            return this.isSpecificPriceVisible() && !this.discount.isSpread;
        }

        canSelectAll() {
            if (this.discount.type === 0
                && this.selectedPredefinedDiscounts
                && this.selectedPredefinedDiscounts.details
                && this.selectedPredefinedDiscounts.details.isRedeemableLimitApplicable
                && this.selectedPredefinedDiscounts.details.discountRedeemableLimitPerTypeEnum == Model.DiscountRedeemableLimitPerTypeEnum.Client) {
                return _.chain(this.discountItems).map((item) => { return item.item.clientId; }).uniqueId().value().length == 1;
            }
            return true;
        }

        focusOnScanBarCode() {
            this.$timeout(() => {
                let inputScan = $('#LABEL_SCAN_DISCOUNT_BARCODE');
                if (inputScan.length > 0) {
                    inputScan[0].focus();
                }
            }, 200);
        }

        searchAndApplyScannedDiscountId = _.debounce(() => {
            if (Model.Guard.isSomething(this.scannedDiscountBarCode) && this.scannedDiscountBarCode.trim() != "") {
                this.registerContext.searchAndApplyScannedDiscountId(this.scannedDiscountBarCode)
                    .then(() => {
                        this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
                    }).finally(() => {
                        this.scannedDiscountBarCode = "";
                    });
            }
        }, 300);

        groupItemsByClient(itemsToGroup: any[]) {
            let toBeGroupedList = [];

            _(itemsToGroup).each((item) => {
                toBeGroupedList.push({
                    clientId: item.item.clientId,
                    clientType: item.item.clientType,
                    displayName: item.item.client ? item.item.client.displayName : item.item.clientDisplayName
                });
            });

            return _(toBeGroupedList).groupBy((item) => [item.clientId, item.clientType]);
        }

        removeDiscounts(saleLine) {
            const removedDiscountLines = _(saleLine.discountLines).filter(discountLine => this.isDiscount(discountLine))
            saleLine.discountLines = _(saleLine.discountLines).without(...removedDiscountLines);
            return removedDiscountLines;
        }

        isSpreadChange() {
            if (this.discount.isSpread) {
                this.discount.discountValueSpread = this.discount.discountValue;
            }
            else {
                this.discount.discountValue = this.discount.discountValueSpread;
            }
        }
    }
}
